import { Either, Failure } from '../../../core/core'
import {
  subscriptionsDelete,
  subscriptionsGet,
  subscriptionsGetOne,
  subscriptionsPost,
  subscriptionsPut,
} from '../../../data/repositories/subscriptions/SubscriptionRepositories'

import {
  ISubscription,
  ISubscriptionApiResponse,
  ICreateSubscriptionPayload,
  IUpdateSubscriptionPayload,
} from '../../interfaces/ISubscription'

export async function getSubscriptions(queryString?: string): Promise<Either<Failure, ISubscriptionApiResponse>> {
  return await subscriptionsGet(queryString)
}

export async function getSubscription(id: string): Promise<Either<Failure, ISubscription>> {
  return await subscriptionsGetOne(id)
}

export async function createSubscription(data: ICreateSubscriptionPayload): Promise<Either<Failure, ISubscription>> {
  return await subscriptionsPost(data)
}

export async function updateSubscription(
  id: string,
  data: IUpdateSubscriptionPayload,
): Promise<Either<Failure, ISubscription>> {
  return await subscriptionsPut(id, data)
}

export async function deleteSubscription(id: string): Promise<Either<Failure, ISubscription>> {
  return await subscriptionsDelete(id)
}
